module.exports = __webpack_public_path__ + "img/sim.3c834714.png";